module.exports = __webpack_public_path__ + "static/media/preview_teams.cbcef144.PNG";